import React from 'react';

export const useOutsideClick = (refs, handler, outsideClick) => {
  React.useEffect(() => {
    if (!outsideClick) return;
    const listener = event => {
      if (!refs.current || refs.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document?.addEventListener('mousedown', listener);
    document?.addEventListener('touchstart', listener);
    return () => {
      document?.removeEventListener('mousedown', listener);
      document?.removeEventListener('touchstart', listener);
    };
  }, [refs, handler, outsideClick]);
};
